import { render, staticRenderFns } from "./latestTx.vue?vue&type=template&id=8561084e&scoped=true&"
import script from "./latestTx.vue?vue&type=script&lang=js&"
export * from "./latestTx.vue?vue&type=script&lang=js&"
import style0 from "./latestTx.vue?vue&type=style&index=0&id=8561084e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8561084e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8561084e')) {
      api.createRecord('8561084e', component.options)
    } else {
      api.reload('8561084e', component.options)
    }
    module.hot.accept("./latestTx.vue?vue&type=template&id=8561084e&scoped=true&", function () {
      api.rerender('8561084e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/center/latestTx.vue"
export default component.exports